import { scheduleInputToUtcIso } from "@common/utils/adsetSchedule";
import type {
  LaunchCampaignCreativeApi,
  LaunchCampaignTargetingWire,
} from "@common/interfaces/adsManagerGuidedEdit";
import type {
  CreativeBlock,
  GuidedTargetingInput,
} from "../guidedFlow/types";
import type { BudgetData } from "../components/GuidedBudgetEditor";
import { guidedEditWiredBudgetToLaunchCampaignWire } from "./guidedCampaignBudgetWire";
import { wireGuidedEditBudgetFromFormDollars } from "./wireGuidedEditBudgetFromForm";

export function mapCreativeBlocksToLaunchCreatives(
  creatives: CreativeBlock[]
): LaunchCampaignCreativeApi[] {
  return creatives.map((c) => ({
    name: c.name ?? "",
    primary_text: (c.primaryText ?? "").trim(),
    ...(c.squareMediaUrl ? { square_url: c.squareMediaUrl } : {}),
    ...(c.squareMediaFileKey ? { square_file_key: c.squareMediaFileKey } : {}),
    ...(c.squareMediaType ? { square_media_type: c.squareMediaType } : {}),
    ...(c.verticalMediaUrl ? { portrait_url: c.verticalMediaUrl } : {}),
    ...(c.verticalMediaFileKey
      ? { portrait_file_key: c.verticalMediaFileKey }
      : {}),
    ...(c.verticalMediaType
      ? { portrait_media_type: c.verticalMediaType }
      : {}),
    fb_page_id: c.fbPage?.id ?? "",
    fb_page_name: c.fbPage?.name ?? "",
    instagram_id: c.instagramAccount?.id ?? "",
    instagram_name: c.instagramAccount?.username ?? "",
  }));
}

export function mapGuidedTargetingToLaunchWire(
  targeting: GuidedTargetingInput | undefined
): LaunchCampaignTargetingWire {
  return {
    strategy: targeting?.strategy ?? "template",
    ...(targeting?.custom_audiences?.length
      ? { custom_audiences: targeting.custom_audiences }
      : {}),
    ...(targeting?.locations ? { locations: targeting.locations } : {}),
    ...(targeting?.demographics
      ? { demographics: targeting.demographics }
      : {}),
    ...(targeting?.enabled_strategy_ids?.length
      ? { enabled_strategy_ids: targeting.enabled_strategy_ids }
      : {}),
  };
}

export function wireFormBudgetToLaunchCampaignWire(
  budget: BudgetData | undefined,
  eventTimezone: string
) {
  const wired = wireGuidedEditBudgetFromFormDollars(
    budget ?? {},
    eventTimezone
  );
  return guidedEditWiredBudgetToLaunchCampaignWire(wired);
}

export function wireFormScheduleToLaunchSchedule(
  schedule: { start_at: string; end_at: string },
  eventTimezone: string
) {
  return {
    start_at: scheduleInputToUtcIso(schedule.start_at, eventTimezone)!,
    end_at: scheduleInputToUtcIso(schedule.end_at, eventTimezone)!,
  };
}
